import { useCore } from '@/composables/core'
import { PRICE_TYPES } from '@/lib/consts'
import { formatCurrency } from '../format-currency'

type ServicePriceVariant = {
  type?: string
  price?: string | number
}

type ServicePriceInput = ServicePriceVariant & {
  variant?: ServicePriceVariant
}

export const formatServicePrice = (value: ServicePriceInput): string => {
  const { t } = useCore()
  const variant: ServicePriceVariant = (value && value.variant) ? value.variant : value || {}
  switch (variant.type) {
    case PRICE_TYPES.FIXED:
      return formatCurrency(variant.price as number)
    case PRICE_TYPES.STARTS_AT:
      return formatCurrency(variant.price as number) + '+'
    case PRICE_TYPES.FREE:
      return t('free')
    case PRICE_TYPES.VARIES:
      return t('varies')
    case PRICE_TYPES.DONT_SHOW:
      return t('do_not_show')
    default:
      return ''
  }
}
